export default {
  sort: '-createDate',
  filter: '',
  search: '',
  contentCategories: [],
  tags: [],
  type: '',
};
